import React from 'react'
import {Box} from '@chakra-ui/react'

interface EditorialFixedHeaderProps {
    pageId: string
    children: React.ReactNode
}

/**
 * Full Page with Fixed Header layout for Page Designer editorial pages.
 * Page type: fullPageFixedHeader
 *
 * Header transparency is managed by the HeaderContext via setTransparentMode(true)
 * in the parent Editorial page component.
 */
const EditorialFixedHeader = ({pageId, children}: EditorialFixedHeaderProps): JSX.Element => {
    return (
        <Box data-testid={`editorial-fixed-${pageId}`} id={pageId}>
            {children}
        </Box>
    )
}

export {EditorialFixedHeader}
